import { locatorServiceAPI } from 'shared/services';

import {
  Service,
  ServiceFormat,
  AdditionalService
} from '../types';

export const servicesAPI = {
  getServiceFormats: () => locatorServiceAPI.get<ServiceFormat[]>('service-formats'),
  getAdditionalServices: () => locatorServiceAPI.get<AdditionalService[]>('additional-services'),
  getServices: () => locatorServiceAPI.get<Service[]>('services')
};
